import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { importModalAtom } from '@/atoms/import';
import { Button } from '@/components/ui/button';
import { Text } from '@/components/ui/text';
import { ImportRepeatBlock } from './ImportScript.styles';

export const ImportScriptRepeat = () => {
    const { t } = useTranslation();
    const setImportModal = useSetAtom(importModalAtom);
    return (
        <ImportRepeatBlock onClick={() => setImportModal(prev => ({ ...prev, ready: false }))}>
            <Button variant="actions" size="small" children={<ArrowBackIcon fontSize="small" />} />
            <Text variant="subtitle2" color="text-inherit" children={t('import.check-repeat')} />
        </ImportRepeatBlock>
    );
};
